import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { AdCampaignsPage } from './pages/AdCampaignsPage';
import { AutomationsPage } from './pages/AutomationsPage';
import { WebDesignSeoPage } from './pages/WebDesignSeoPage';
import { PricingPage } from './pages/PricingPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { RobotsTxt } from './pages/RobotsTxt';
import { SitemapXml } from './pages/SitemapXml';
function SiteLayout() {
  return <div className="flex flex-col min-h-screen bg-viridia-black font-sans text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <noscript data-id="element-2">
        <div style={{
        padding: '2rem',
        maxWidth: '800px',
        margin: '0 auto'
      }} data-id="element-3">
          <h1 data-id="element-4">
            Viridia Analytics — Phoenix Marketing Agency for Local Service
            Businesses
          </h1>
          <p data-id="element-5">
            Phoenix's #1 growth partner for local service businesses. Expert ad
            campaigns on Google, Meta &amp; Yelp, smart automations, CRM
            follow-up, and web design that turns clicks into booked jobs.
          </p>
          <h2 data-id="element-6">Our Services</h2>
          <ul data-id="element-7">
            <li data-id="element-8">
              <a href="/ad-campaigns" data-id="element-9">
                Ad Campaign Management — Google Ads, Meta Ads, Yelp Ads
              </a>
            </li>
            <li data-id="element-10">
              <a href="/automations" data-id="element-11">
                Marketing Automations — CRM, Follow-Up, Lead Nurturing
              </a>
            </li>
            <li data-id="element-12">
              <a href="/web-design-seo" data-id="element-13">Web Design &amp; Local SEO</a>
            </li>
          </ul>
          <h2 data-id="element-14">Contact Us</h2>
          <p data-id="element-15">
            Phone: <a href="tel:6233000708" data-id="element-16">(623) 300-0708</a>
          </p>
          <p data-id="element-17">
            Email:{' '}
            <a href="mailto:info@viridiaanalytics.com" data-id="element-18">
              info@viridiaanalytics.com
            </a>
          </p>
          <p data-id="element-19">Location: Phoenix, AZ — Serving Local Businesses</p>
          <h2 data-id="element-20">Quick Links</h2>
          <ul data-id="element-21">
            <li data-id="element-22">
              <a href="/about" data-id="element-23">About Us</a>
            </li>
            <li data-id="element-24">
              <a href="/pricing" data-id="element-25">Pricing</a>
            </li>
            <li data-id="element-26">
              <a href="/contact" data-id="element-27">Book a Free Strategy Call</a>
            </li>
            <li data-id="element-28">
              <a href="/privacy" data-id="element-29">Privacy Policy</a>
            </li>
            <li data-id="element-30">
              <a href="/terms" data-id="element-31">Terms of Service</a>
            </li>
          </ul>
        </div>
      </noscript>
      <main role="main" className="flex-grow" data-id="element-32">
        <Routes data-id="element-33">
          <Route path="/" element={<HomePage data-id="element-35" />} data-id="element-34" />
          <Route path="/services" element={<Navigate to="/ad-campaigns" replace data-id="element-37" />} data-id="element-36" />
          <Route path="/ad-campaigns" element={<AdCampaignsPage data-id="element-39" />} data-id="element-38" />
          <Route path="/automations" element={<AutomationsPage data-id="element-41" />} data-id="element-40" />
          <Route path="/web-design-seo" element={<WebDesignSeoPage data-id="element-43" />} data-id="element-42" />
          <Route path="/pricing" element={<PricingPage data-id="element-45" />} data-id="element-44" />
          <Route path="/about" element={<AboutPage data-id="element-47" />} data-id="element-46" />
          <Route path="/contact" element={<ContactPage data-id="element-49" />} data-id="element-48" />
          <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-51" />} data-id="element-50" />
          <Route path="/terms" element={<TermsOfServicePage data-id="element-53" />} data-id="element-52" />
        </Routes>
      </main>
      <Footer data-id="element-54" />
    </div>;
}
export function App() {
  useEffect(() => {
    // GHL Chat Widget
    const chatDiv = document.createElement('div');
    chatDiv.setAttribute('data-chat-widget', '');
    chatDiv.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    chatDiv.setAttribute('data-location-id', 'JLycxFbUVQFY3z4zPpCS');
    document.body.appendChild(chatDiv);
    const script = document.createElement('script');
    script.src = 'https://widgets.leadconnectorhq.com/loader.js';
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    document.body.appendChild(script);
    return () => {
      if (chatDiv.parentNode) chatDiv.parentNode.removeChild(chatDiv);
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);
  return <BrowserRouter data-id="element-55">
      <ScrollToTop data-id="element-56" />
      <Routes data-id="element-57">
        <Route path="/robots.txt" element={<RobotsTxt data-id="element-59" />} data-id="element-58" />
        <Route path="/sitemap.xml" element={<SitemapXml data-id="element-61" />} data-id="element-60" />
        <Route path="/*" element={<SiteLayout data-id="element-63" />} data-id="element-62" />
      </Routes>
    </BrowserRouter>;
}